/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
Buyapowa.Views.FriendSignposting = class FriendSignposting {
  constructor(el, controller) {
    this.onOptionSelected = this.onOptionSelected.bind(this);
    this.onOptionLinks = this.onOptionLinks.bind(this);
    this.onPostPurchaseTrackingKeyPressed = this.onPostPurchaseTrackingKeyPressed.bind(this);
    this.onPostPurchaseTrackingSelected = this.onPostPurchaseTrackingSelected.bind(this);
    this.onPostPurchaseTrackingSubmitClick = this.onPostPurchaseTrackingSubmitClick.bind(this);
    this.onWordOfMouthKeyPressed = this.onWordOfMouthKeyPressed.bind(this);
    this.onWordOfMouthSelected = this.onWordOfMouthSelected.bind(this);
    this.onWordOfMouthSubmitClick = this.onWordOfMouthSubmitClick.bind(this);
    this.showPostPurchaseTrackingForm = this.showPostPurchaseTrackingForm.bind(this);
    this.hidePostPurchaseTrackingForm = this.hidePostPurchaseTrackingForm.bind(this);
    this.postPurchaseTrackingEmailValid = this.postPurchaseTrackingEmailValid.bind(this);
    this.customFieldValid = this.customFieldValid.bind(this);
    this.wordOfMouthValid = this.wordOfMouthValid.bind(this);
    this.enablePostPurchaseTrackingSubmit = this.enablePostPurchaseTrackingSubmit.bind(this);
    this.disablePostPurchaseTrackingSubmit = this.disablePostPurchaseTrackingSubmit.bind(this);
    this.enableWordOfMouthSubmit = this.enableWordOfMouthSubmit.bind(this);
    this.disableWordOfMouthSubmit = this.disableWordOfMouthSubmit.bind(this);
    this.toggleTick = this.toggleTick.bind(this);
    this.hidePostPurchaseTrackingErrorMessage = this.hidePostPurchaseTrackingErrorMessage.bind(this);
    this.showWordOfMouthForm = this.showWordOfMouthForm.bind(this);
    this.hideWordOfMouthForm = this.hideWordOfMouthForm.bind(this);
    this.showWordOfMouthErrorMessage = this.showWordOfMouthErrorMessage.bind(this);
    this.hideWordOfMouthErrorMessage = this.hideWordOfMouthErrorMessage.bind(this);
    this.el = el;
    this.controller = controller;
    this.options = this.el.find('*[data-option]');
    this.optionsLinks = this.options.find('a');

    this.customField = this.el.find('[data-input-tick="custom-field"]');
    this.pptEmail = this.el.find('[data-input-tick="ppt-email"]');
    this.womLookup = this.el.find('[data-input-tick="wom-lookup"]');
    this.womCustomField = this.el.find('[data-wom-custom-field="true"]');

    this.postPurchaseTracking = this.el.find('div.option--post-purchase-tracking');
    this.postPurchaseTrackingForm = this.el.find('form#post-purchase-tracking');
    this.postPurchaseTrackingSubmitButton = this.el.find('button.post-purchase-tracking');

    this.wordOfMouth = this.el.find('div.option--word-of-mouth');
    this.wordOfMouthForm = this.el.find('form#word-of-mouth');
    this.wordOfMouthSubmitButton = this.el.find('button.word-of-mouth');
  }

  onOptionSelected(cb) {
    const ev = e => {
      e.preventDefault();
      const option = $(e.currentTarget).closest("*[data-option]");
      const index = this.options.index(option);

      cb(index);
      return false;
    };

    return this.options.on('click', ev);
  }

  onOptionLinks() {
    return this.optionsLinks.on('click', e => {
      const targetLink = $(e.currentTarget).attr('href'); 
      return window.open(targetLink, "_blank");
    });
  }

  onPostPurchaseTrackingKeyPressed(cb) {
    this.customField.on('input', cb);
    return this.pptEmail.on('input', 'input', cb);
  }

  onPostPurchaseTrackingSelected(cb) {
    return this.postPurchaseTracking.on('click', cb);
  }

  onPostPurchaseTrackingSubmitClick(cb) {
    return this.postPurchaseTrackingSubmitButton.on('click', cb);
  }

  onWordOfMouthKeyPressed(cb) {
    return this.womLookup.on('input', 'input', cb);
  }

  onWordOfMouthSelected(cb) {
    return this.wordOfMouth.on('click', cb);
  }

  onWordOfMouthSubmitClick(cb) {
    return this.wordOfMouthSubmitButton.on('click', cb);
  }

  setOptionSelected(index, value) {
    return this._optionByIndex(index).toggleClass("is-selected", value);
  }

  setOptionUnselected(index, value) {
    return this._optionByIndex(index).toggleClass("is-unselected", value);
  }

  _optionByIndex(index) {
    return $(this.options.get(index));
  }

  showPostPurchaseTrackingForm() {
    this.el.find('.reveal-post-purchase-tracking').addClass('hide');
    return this.el.find('.post-purchase-tracking-revealed').removeClass('hide');
  }

  hidePostPurchaseTrackingForm() {
    if (this.postPurchaseTracking.length > 0) {
      this.el.find('.reveal-post-purchase-tracking').removeClass('hide');
      this.el.find('.post-purchase-tracking-revealed').addClass('hide');
      $(this.postPurchaseTrackingForm)[0].reset();
      $(this.customField).removeClass('tick');
      $(this.pptEmail).removeClass('tick');
      return this.hidePostPurchaseTrackingErrorMessage();
    }
  }

  postPurchaseTrackingEmailValid() {
    return new Buyapowa.Helpers.EmailValidator(this.pptEmail.find('input').val()).isValid();
  }

  customFieldValid() {
    if (!this.customField.length) { return true; }
    return new Buyapowa.Helpers.CustomSignupFieldValidator(this.customField.find('input')).isValid();
  }

  wordOfMouthValid() {
    const emailValid = new Buyapowa.Helpers.EmailValidator(this.womLookup.find('input').val()).isValid();
    if (this.womCustomField.length) { return emailValid || new Buyapowa.Helpers.CustomSignupFieldValidator(this.womLookup.find('input')).isValid(); }
    return emailValid;
  }

  enablePostPurchaseTrackingSubmit() {
    return this.postPurchaseTrackingSubmitButton.removeAttr('disabled');
  }

  disablePostPurchaseTrackingSubmit() {
    if (this.postPurchaseTracking.length > 0) {
      return this.postPurchaseTrackingSubmitButton.attr('disabled','disabled');
    }
  }

  enableWordOfMouthSubmit() {
    return this.wordOfMouthSubmitButton.removeAttr('disabled');
  }

  disableWordOfMouthSubmit() {
    if (this.wordOfMouth.length > 0) {
      return this.wordOfMouthSubmitButton.attr('disabled','disabled');
    }
  }

  toggleTick() {
    this.pptEmail.toggleClass('tick', this.postPurchaseTrackingEmailValid());
    this.customField.toggleClass('tick', this.customFieldValid());
    return this.womLookup.toggleClass('tick', this.wordOfMouthValid());
  }

  getPostPurchaseTrackingUrl() {
    return this.postPurchaseTrackingForm.attr('action');
  }

  getPostPurchaseTrackingData() {
    return this.postPurchaseTrackingForm.serializeObject();
  }

  redirectToFriendConfirmationPage() {
    return window.open($(this.postPurchaseTrackingForm).data("confirmation-url"),'_self');
  }

  showPostPurchaseTrackingErrorMessage() {
    return this.el.find('.error-message--post-purchase-tracking').removeClass('hide');
  }

  hidePostPurchaseTrackingErrorMessage() {
    return this.el.find('.error-message--post-purchase-tracking').addClass('hide');
  }

  showWordOfMouthForm() {
    this.el.find('.reveal-word-of-mouth').addClass('hide');
    return this.el.find('.word-of-mouth-revealed').removeClass('hide');
  }

  hideWordOfMouthForm() {
    if (this.wordOfMouth.length > 0) {
      this.el.find('.reveal-word-of-mouth').removeClass('hide');
      this.el.find('.word-of-mouth-revealed').addClass('hide');
      $(this.wordOfMouthForm)[0].reset();
      $(this.womLookup).removeClass('tick');
      return this.hideWordOfMouthErrorMessage();
    }
  }

  showWordOfMouthErrorMessage() {
    return this.el.find('.error-message--word-of-mouth').removeClass('hide');
  }

  hideWordOfMouthErrorMessage() {
    return this.el.find('.error-message--word-of-mouth').addClass('hide');
  }

  getWordOfMouthUrl() {
    return this.wordOfMouthForm.attr('action');
  }

  getWordOfMouthData() {
    return this.wordOfMouthForm.serializeObject();
  }
};
